import React from 'react'
import Youtube3D from '../youtube-3D'

const Bond = (props) => {
    const images = [
        './youtube/toplane.png',
        './youtube/philipbond.png',
        './youtube/elrond.png',
    ]

    return (
    <Youtube3D 
        images={images}
        name="Boardgamers Target Ad"
        youtubeId="zn5LWdKlGTU"
        {...props}
    />
  )
}

export default Bond